<template>
    <div class="row-buttons">
        <a :href="tme" @click.prevent="telegram">
            <div class="icon"><img src="../assets/img/telegram.svg" alt="Telegram"></div>
            <div>
                <span>Telegram chanel</span>
            </div>
        </a>
        <a href="#" @click.prevent="showModal">
            <div class="icon"><img src="../assets/img/newspaper.svg" alt="NewsPaper"></div>
            <div>
                <span>News</span>
            </div>
        </a>
        <a href="#" @click.prevent="showModal">
            <div class="icon"><img src="../assets/img/api.svg" alt="Api"></div>
            <div>
                <span>For developers</span>
                <span class="small">Coming soon</span>
            </div>
        </a>
    </div>
</template>

<script>
export default {
  data() {
    return {
      tme: 'https://t.me/topupafrica'
    };
  },
  methods: {
    showModal() {
      this.$store.commit('toggleModal', true);
    },
    telegram() {
      window.open(this.tme, '_blank');
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/rowButtons.vue